import React from "react";
import { Form, Input, Logo, ErrorMsg, Button } from "../../Components";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { post, apis } from "../../Utils/axios";
import { FiMail } from "react-icons/fi";

function ForgotPassword() {
	const NAVIGATE = useNavigate();
	const [Values, setValues] = useState({
		email: "",
	});
	const [Loader, setLoader] = useState();
	const [Error, setError] = useState();
	const [EmailSent, setEmailSent] = useState();

	const onLogin = (e) => {
		setError();
		setLoader(true);
		post(apis.resetPasswordUsingEmail, { ...Values }, (r, e) => {
			if (r) {
				setLoader();
				setEmailSent(true);
			} else if (e) {
				setError(e.response.data.error);
				setLoader();
			}
		});
	};

	return (
		<div className="flex items-center justify-center min-h-screen p-6">
			<div className="flex max-w-md flex-col">
				<Logo className="justify-center mb-4"/>
				<div className="justify-center align-center">
					{EmailSent ? (
						<div className="max-w-md">
						<div className="mt-4 text-5xl font-bold">Check Your Inbox</div>
						<div className="mt-3 text-sm">We just dropped you a mail to set a new password. Follow the email instructions.</div>
						<div className="flex justify-center">
							<Button onClick={() => NAVIGATE("/")} loading={Loader} className="mt-6">
								Go To Log In
							</Button>
						</div>
					</div>
					) : (
						<div className="max-w-md">
							<div className="flex text-4xl font-bold">Password Reset</div>
							<div className="mt-1 text-sm">Enter your email and we will send you a reset password link.</div>
							<div className="flex flex-col mt-10">
								<Form onSubmit={onLogin}>
									<Input value={Values.email} onChange={(email) => setValues((prev) => ({ ...prev, email: email.toLowerCase() }))} required label="Email" placeholder="Email" />
									<ErrorMsg e={Error} />
									<Button loading={Loader} variant="primary" type="submit" className="w-full mt-4">
										Send Link
									</Button>
								</Form>

								<div onClick={() => NAVIGATE("/login")} className="mt-4 text-sm text-center cursor-pointer hover:underline">
									Go To Log In
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default ForgotPassword;
